export default function listWidth(value) {
  if (value > 550) {
    return false;
  } else {
    return true;
  }
}
